import CitySEOHead from "@/components/feature/CitySEOHead";
import HeroSection from "./components/HeroSection";
import StickyNav from "./components/StickyNav";
import ProcessingTimeSection from "./components/ProcessingTimeSection";
import ServicesSection from "./components/ServicesSection";
import HowItWorksSection from "./components/HowItWorksSection";
import LocalAreaSection from "./components/LocalAreaSection";
import TestimonialsSection from "./components/TestimonialsSection";
import AcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import ComparisonSection from "./components/ComparisonSection";
import MistakesSection from "./components/MistakesSection";
import FAQSection from "./components/FAQSection";
import HelpfulResourcesSection from "./components/HelpfulResourcesSection";
import FinalCTA from "./components/FinalCTA";

const pageTitle = "Emergency Passport Cheyenne, WY — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Fast Passport Center provides emergency, expedited, and same-day passport services in Cheyenne, Wyoming. Serving Laramie County, Warren AFB, and surrounding areas. As fast as 24 hours — no Denver agency trip needed.";
const cheyenneFaqs = [
  { q: "How do I get an expedited passport in Cheyenne, Wyoming?", a: "Cheyenne residents can use Fast Passport Center for 2–9 day expedited processing. Ship documents overnight and we handle agency submission remotely. The nearest regional agency is in Denver, 100 miles south." },
  { q: "Where is the nearest passport agency to Cheyenne?", a: "The Denver Regional Passport Agency (3151 S Vaughn Way, Suite 600, Aurora, CO 80014) is approximately 100 miles south of Cheyenne via I-25. It requires an appointment for emergencies only. Fast Passport Center eliminates that trip." },
];

export default function CheyennePage() {
  return (
    <>
      <CitySEOHead
        city="Cheyenne"
        state="Wyoming"
        stateAbbr="WY"
        route="/cities/cheyenne"
        officeHours={[
          { dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"], opens: "08:00", closes: "18:00" },
          { dayOfWeek: "Saturday", opens: "09:00", closes: "14:00" },
        ]}
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Cheyenne, Wyoming"
        geoPosition="41.1400;-104.8202"
        keywords="expedited passport Cheyenne, emergency passport Cheyenne WY, same day passport Cheyenne, fast passport Wyoming, passport renewal Cheyenne, Laramie County passport, Warren AFB passport"
        faqs={cheyenneFaqs}
        servicesSchema={[]}
        statePageName="Wyoming"
        statePageRoute="/states/wyoming"
        lastModified="2026-06-09"
        serviceAreaDesc="Expedited and emergency passport services for Cheyenne, WY and Laramie County. As fast as 24 hours. No Denver agency trip needed."
      />

      <div className="min-h-screen bg-white">
      <HeroSection />
      <StickyNav />
      <ProcessingTimeSection />
      <LocalAreaSection />
      <ServicesSection />
      <HowItWorksSection />
      <TestimonialsSection />
      <AcceptanceFacilitiesSection />
      <ComparisonSection />
      <MistakesSection />
      <FAQSection />
      <HelpfulResourcesSection />
      <FinalCTA />
      </div>
    </>
  );
}